<template>
    <ResponsiveImage :image-url="imageUrl" width="76px" class="logo"/>
</template>

<script>
import PaymentPlanType from "@/model/apply/PaymentPlanType";
import LocalizedComponentMixin from "@/components/localization/LocalizedComponentMixin";

export default {
    mixins: [
        LocalizedComponentMixin,
    ],
    props: {
        provider: {
            type: Object,
            required: true,
        },
        paymentPlan: {
            type: Object,
            required: true,
        },
    },
    computed: {
        imageUrl() {
            const subLender = this.provider.subLender
            const showSubLender = subLender && this.paymentPlan.typeId === PaymentPlanType.SUB_LENDER_FIXED_LOAN
            if (showSubLender) {
                return this.provider.subLender.logo
            }
            return this.provider.logo
        }
    }
}
</script>
